import React from 'react'

import {SelectParent_RenderType} from "../../../@const"
import SelectParentsNew from "../../../select-parents-new"

type Props = {
    className?  : string

    parent      : SelectParentsNew
}

export default function SelectParent_ValueMulti(props: Props) {

    const onDeleteProject = (e: React.MouseEvent, id: ID) => {
        e.stopPropagation()
        parent.onParentSelected(id)
    }

    let projectItems: any[] = []
    const parent = props.parent

    _.map(parent.state.values, (pId: ID) => {
        const project = gd.session.projects.get(pId)
        if (project) {
            projectItems.push(
                <div key={project.id} className="item">
                    {project.name}

                    {!props.parent.props.disabled &&
                        <div className  = "i5-delete-circle-solid delete-icon"
                             onClick    = {(e)=>onDeleteProject(e, project.id)}/>}
                </div>
            )
        }
    })

    const result = projectItems.length > 0 ? projectItems : <span>{parent.props.placeholder}</span>

    switch (parent.props.renderType) {
        case SelectParent_RenderType.FORM: {
            const classes = Classes('cur-value', parent.props.curValueClasses, {
                'no-value': projectItems.length === 0
            })

            return (
                <div className={classes} onClick={parent.showPopover}>
                    {result}
                    <div className="i5-big-angle-down"/>
                </div>
            )
        }

        case SelectParent_RenderType.INLINE_EDITABLE: {
            const classes = Classes('cur-value', parent.props.curValueClasses, {
                'no-value fl-ac': projectItems.length === 0,
                'p-b-0'         : projectItems.length === 1,
            })

            return (
                <div className={classes} onClick={parent.showPopover}>
                    {result}
                </div>
            )
        }

        default:
            throw Error('#DJD39383 Multi value mode not supported')
    }
}
